// Dependencies
import React, { useState } from 'react';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { Icon, divIcon, point } from 'leaflet';

const DEFAULT_COORDS = [-16.524568684632587, -68.21297334607009];
// const DEFAULT_COORDS = [-17.970568939360767,-67.09246867037233]; //oruro

const MapComponentEdit = ({ data, onChange }) => {
  // Obtiene coordenadas iniciales
  const initialCoords = data?.geolocalizacion
    ? data.geolocalizacion.split(',').map(Number)
    : DEFAULT_COORDS;

  const [markerPosition, setMarkerPosition] = useState(
    initialCoords.length === 2 && !initialCoords.includes(NaN)
      ? initialCoords
      : DEFAULT_COORDS
  );

  // Mueve marcador al arrastrarlo
  const handleDragEnd = (event) => {
    const { lat, lng } = event.target.getLatLng();
    const newGeo = `${lat},${lng}`;
    setMarkerPosition([lat, lng]);
    onChange?.(newGeo);
  };

  // Maneja click en el mapa
  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setMarkerPosition([lat, lng]);
        onChange?.(`${lat},${lng}`);
      },
    });
    return null;
  };

  // Obtener ubicación actual del navegador
  const handleCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setMarkerPosition([latitude, longitude]);
          onChange?.(`${latitude},${longitude}`);
        },
        (error) => {
          console.error("No se pudo obtener la ubicación:", error);
          alert("No se pudo obtener la ubicación actual.");
        }
      );
    } else {
      alert("Geolocalización no soportada en este navegador.");
    }
  };

  // Iconos
  const customIcon = new Icon({
    iconUrl: require('./location.png'),
    iconSize: [26, 26],
  });

  const createCustomClusterIcon = (cluster) =>
    new divIcon({
      html: `<div class='cluster-icon'>${cluster.getChildCount()}</div>`,
      className: 'custom-marker-cluster',
      iconSize: point(28, 28, true),
    });

  return (
    <div>
      <button
        type="button"
        onClick={handleCurrentLocation}
        style={{
          marginBottom: "10px",
          padding: "6px 12px",
          borderRadius: "6px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        Obtener ubicación actual
      </button>

      <MapContainer
        center={markerPosition}
        zoom={13}
        style={{ height: '400px', width: '100%' }}
      >
        <MapClickHandler />
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <MarkerClusterGroup
          chunkedLoading
          iconCreateFunction={createCustomClusterIcon}
        >
          <Marker
            position={markerPosition}
            icon={customIcon}
            draggable={true}
            eventHandlers={{ dragend: handleDragEnd }}
          />
        </MarkerClusterGroup>
      </MapContainer>
    </div>
  );
};

export default MapComponentEdit;
